<template>
  <form
    class="dropzone"
    :id="bucket"
    :key="bucket"
  >

    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div
      :id="'dropzone-message-' + bucket"
      style="display: none"
    >
      <span class="dropzone-title">
        <v-btn
          flat
          icon
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </span>
    </div>
  </form>
</template>

<script>
import generateId from "@/idGenerator";
import mime from "mime";
import EXIF from "exif-js";
import { getApi } from "../../api";
import { setTimeout } from "timers";

export default {
  name: "my-dropzone",
  data() {
    return {};
  },
  methods: {
    addFile(file) {
      file.description = "";
      this.$store.dispatch("uploader/ADD_FILE", {
        bucket: this.bucket,
        file: Object.assign({}, file)
      });

      this.$store.dispatch("uploader/SET_FILE_DATA", {
        filename: file.upload.filename,
        bucket: this.bucket,
        data: {
          filename: file.name,
          server_filename: file.upload.filename,
          filetype: file.upload.filename.split(".").pop()
        }
      });

      // if (this.isFiles) {
      //   console.log("uploader/SET_FILE_DATA put file name");

      // } else {
      //   this.$store.dispatch("uploader/SET_FILE_DATA", {
      //     filename: file.upload.filename,
      //     bucket: this.bucket,
      //     data
      //   });
      // }
    },

    setData(filename, data) {
      this.$store.dispatch("uploader/SET_FILE_DATA", {
        filename,
        bucket: this.bucket,
        data
      });
    },

    setStatus(filename, status) {
      this.$store.dispatch("uploader/SET_FILE_STATUS", {
        filename,
        bucket: this.bucket,
        status
      });
    },

    getSignedURL(filesNames, type) {
      console.log("getSignedURL");
      let params = {
        filesNames: filesNames,
        fileType: type
      };
      return getApi().then(api => {
        return api.get("/sign-s3", { params });
      });
    }
  },
  props: ["bucket", "title", "icon", "uploadFolder", "isFiles"],
  mounted() {
    const vm = this;

    let Dropzone = require("dropzone");
    Dropzone.autoDiscover = false;

    this.$nextTick(function() {
      setTimeout(() => {
        
        let options = {
          // The URL will be changed for each new file being processing
          url: "/",
          acceptedFiles: this.isFiles ? null : "image/*",
          maxFilesize: this.isFiles ? 50 : 50,

          // Since we're going to do a `PUT` upload to S3 directly
          method: "put",
          // Hijack the xhr.send since Dropzone always upload file by using formData
          // ref: https://github.com/danialfarid/ng-file-upload/issues/743
          sending(file, xhr) {
            let _send = xhr.send;
            xhr.send = () => {
              _send.call(xhr, file);
            };
          },
          // Upload one file at a time since we're using the S3 pre-signed URL scenario
          parallelUploads: 1,
          uploadMultiple: false,
          timeout: 0,
          // Content-Type should be included, otherwise you'll get a signature
          // mismatch error from S3. We're going to update this for each file.
          //header: '',
          // headers: {
          //   'cache-control': 'public, max-age=31536000',
          // },
          // Customize the wording
          dictDefaultMessage: document.querySelector(
            "#dropzone-message-" + this.bucket
          ).innerHTML,
          // We're going to process each file manually (see `accept` below)
          autoProcessQueue: false,
          // Here we request a signed upload URL when a file being accepted
          accept(file, done) {
            vm.addFile(file);

            vm.getSignedURL(
              vm.uploadFolder + "/" + file.upload.filename,
              file.type
            )
              .then(({ data }) => {
                file.signedRequest = data[0].signedRequest;
                file.url = data[0].url;
                done();
                // Manually process each file
                setTimeout(() => vm.dropzone.processFile(file));
              })
              .catch(err => {
                done("Failed to get an S3 signed upload URL", err);
              });
          },
          renameFile(file) {
            console.log("renameFile", file);
            let suffix = mime.getExtension(file.type);
            if (!suffix) {
              suffix = file.name.split(".").pop();
            }
            return generateId() + "." + suffix;
          },
          error(file, errorMessage) {
            console.log(errorMessage);
          },
          addedfile: function(file) {
            // Do nothing.
            return;
          }
        };

        // Instantiate Dropzone
        let el = document.getElementById(this.bucket);
        this.dropzone = new Dropzone(el, options);

        // Set signed upload URL for each file
        vm.dropzone.on("processing", file => {
          console.log("processing");
          vm.dropzone.options.url = file.signedRequest;
          vm.dropzone.options.headers = {
            "Cache-Control": "public, max-age=31536000"
          };
        });

        // On image upload complete
        vm.dropzone.on("complete", file => {
          console.log("complete");

          if (file.status === "success") {
            console.log("complete", file);

            // if (!this.isFiles) {
            //   let data = {};
            //   let width = file.width;
            //   let height = file.height;

            //   let orientation = file.exifdata.Orientation;
            //   if (orientation && orientation >= 5 && orientation <= 8) {
            //     data.width = height;
            //     data.height = width;
            //   } else {
            //     data.width = width;
            //     data.height = height;
            //   }

            //   vm.setData(file.upload.filename, data);
            // }

            vm.setStatus(file.upload.filename, "uploaded");
          } else {
            console.log("error", file);
            if (file.upload) {
              vm.setStatus(file.upload.filename, "upload-error");
            }
          }
        });
      }, 1);
    });
  }
};
</script>

<style lang='scss'>
.dropzone {
  display: inline;
}

.dz-message {
  display: inline;
}
</style>


// WEBPACK FOOTER //
// src/components/uploader/MyDropzone.vue